module.exports = __webpack_public_path__ + "img/jian.ddf29a2c.png";